<template>
  <v-row justify="end">
    <v-dialog v-model="dialog" scrollable width="500px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="secondary" fab dark small style="z-index:4; position: relative; top:-25px;">
          <i class="mdi mdi-24px mdi-spin mdi-settings"></i>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-uppercase body-1 font-weight-medium">
          Configuration Data
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-simple-table dense>
                <template v-slot:default>
                <tbody>
                    <tr v-for="(item, index) in configuration"
                        :key="index"
                        class="text-left subheading"
                        >
                        <td>{{ item.name }}:</td>
                        <td><strong>{{ item.value }}</strong></td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" small dark color="primary">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
export default {
  name: "ConfigPopout",
  props: {
    json: {
      type: Object,
      required: true
    }
  },
    data () {
        return {
            dialogm1: '',
            dialog: false,
            configuration: false
        }
    },
    created() {
        this.parse()
    },
    methods: {
        parse() {
        this.parsed = false
        this.configuration = []
        let s = JSON.stringify(this.json)
        let noLeftBraces = s.replace(new RegExp('{', 'g'), '')
        let noRightBraces = noLeftBraces.replace(new RegExp('}', 'g'), '')
        let noQuotes = noRightBraces.replace(new RegExp('"', 'g'), '')
        let array = noQuotes.split(',')
        for (var c = 0; c < array.length; c++) {
            let key = this.getKey(array[c])
            let val = this.getValue(array[c])
            let unit = this.getUnit(array[c])

            this.configuration.push({
            name: key,
            value: val + ' ' + unit
            })
        }
        this.parsed = true
        },
        getKey(obj) {
        return startCase(obj.split(':')[0])
        },
        getValue(obj) {
        let key = this.getKey(obj)
        let keyLwr = toLower(key)
        let val = obj.split(':')[1]

        if (keyLwr.indexOf('cost') > -1 || keyLwr.indexOf('price') > -1) {
            return '$' + parseFloat(val).toFixed(2)
        }
        if (val == 'false') {
            return 'No (false)'
        }
        if (val == 'true') {
            return 'Yes (true)'
        }
        return val
        },

        getUnit(obj) {
        let key = this.getKey(obj).toLowerCase()
        if (key.indexOf('kw') > -1) {
            return 'kW'
        }
        if (key.indexOf('minutes') > -1) {
            return 'minutes'
        }
        if (key.indexOf('time') > -1) {
            return 'minutes'
        }
        if (key.indexOf('threshold') > -1) {
            return '%'
        }
        return ''
        }
    }
}
</script>